/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Notion_Kb1Inputs */

const en_mk_cmp_notion_kb1 = /** @type {(inputs: Mk_Cmp_Notion_Kb1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A firm tracker: statuses, priorities, one assignee, a kanban board.`)
};

const id_mk_cmp_notion_kb1 = /** @type {(inputs: Mk_Cmp_Notion_Kb1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelacak pekerjaan yang tegas: status, prioritas, satu penanggung jawab, papan kanban.`)
};

/**
* | output |
* | --- |
* | "A firm tracker: statuses, priorities, one assignee, a kanban board." |
*
* @param {Mk_Cmp_Notion_Kb1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_notion_kb1 = /** @type {((inputs?: Mk_Cmp_Notion_Kb1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Notion_Kb1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_notion_kb1(inputs)
	return en_mk_cmp_notion_kb1(inputs)
});